import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ControlCheckboxes } from "@bluframe/mightychroma-mightytool-ui";
import Reviews from "components/Reviews";
import config from "config/site";
import Actions from "./Actions";
import { Row, Wrapper } from "./styled";
const EightLeggedFreakReviews = ({ reviewsControlCheckboxesProps }) => (_jsxs(Wrapper, { children: [_jsx(ControlCheckboxes, { ...reviewsControlCheckboxesProps }), config.reviews.map((item) => (_jsx(Row, { children: item.rows.map((row) => (_jsx(Reviews, { actions: _jsx(Actions, { serviceName: row.serviceName }), name: row.name, serviceName: row.serviceName }, row.serviceName))) }, item.id)))] }));
export default EightLeggedFreakReviews;
